"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var makeStepMapper = function (stepMapper, WizardContext) { return function () {
    var _a = react_1.default.useContext(WizardContext), currentStep = _a.currentStep, steps = _a.steps;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: steps.map(function (step, idx) {
            var StepComponent = stepMapper[step];
            return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ height: "100%", sx: { display: currentStep === step ? 'block' : 'none' } }, { children: (0, jsx_runtime_1.jsx)(StepComponent, { stepIdx: idx, stepName: step }) }), step));
        }) }));
}; };
exports.default = makeStepMapper;
